module.exports = __webpack_public_path__ + "img/mastercard.3497f1f7.svg";